import { render, staticRenderFns } from "./Vaccination.vue?vue&type=template&id=09d52f8a"
import script from "./Vaccination.vue?vue&type=script&lang=ts"
export * from "./Vaccination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports